import SelectedStoreBase from "../../../../common/state/modules/globallySelected";
import SingleSelectedProperty from "../../../../common/state/modules/singleSelectedProperty";
import Group from "../../models/group";
import Folder from "../../../document_management/models/folder";

export default class GloballySelected extends SelectedStoreBase {
  static group = new SingleSelectedProperty('group', () => Group);
  static folder = new SingleSelectedProperty('folder', () => Folder);
}